"use client";

import { useContext } from "react";
import dayjs from "dayjs";
import "dayjs/locale/pl";
import { UserContext } from "@/contexts/user-context";
import { TextEffect } from "@/components/ui/motion";

const CURRENT_MONTH_YEAR = dayjs().locale("pl").format("MMMM YYYY");

export const HomeHeader = () => {
  const { displayName } = useContext(UserContext);
  return (
    <div className={"mb-6"}>
      <h1 className={"text-2xl font-bold"}>
        <TextEffect preset="fade-in-blur" per={"char"}>
          {`Dzień dobry, ${displayName}.`}
        </TextEffect>
      </h1>
    </div>
  );
};
